module.exports = __webpack_public_path__ + "static/ga_integration_2-743130317257b5ad8550373e7031efcc.png";